export default __webpack_public_path__ + "static/BannerBlogPosts-d0de48fd68bce793ae73f0bceed54107.jpg";